(function () {
    'use strict';

    angular.module('app').factory('ExternalFormService', ExternalFormService);

    ExternalFormService.$inject = ['$rootScope', 'API', '$http'];

    function ExternalFormService($rootScope, API, $http) {
        var service = {};

        service.apiUrl = $rootScope.appConfig.workers.external_forms;

        service.All = function (params, callback) {
            API.get('/external_forms/filled?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        }

        service.AllByUser = function (user_id, params, callback) {
            var url = `/customer/${user_id}/external_forms?{0}`.format(paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        }

        service.Get = function (filled_form_id, callback) {
            var url = '/external_forms/filled/{0}'.format(filled_form_id);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        }

        service.Delete = function (filled_form_id, callback) {
            var url = '/external_forms/filled/{0}'.format(filled_form_id);
            API.delete(url, null, function (success, data) {
                callback(success, data);
            });
        }

        service.AllForms = function (params, callback) {
            API.get('/external_forms/forms?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        }

        service.FormById = function (form_id, callback) {
            API.get(`/external_forms/forms/${form_id}`, function (success, data) {
                callback(success, data);
            });
        }

        service.getDocument = function(data, callback) {
            $http({
                method: 'POST',
                url: `${service.apiUrl}/api/generate-pdf`,
                data: data
            }).then(function successCallback(data) {
                callback(true, data);
            }, function errorCallback(data) {
                callback(false, data);
            });
        };

        return service;
    }

})();

